var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    viewBox: "0 0 282 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Pm-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pm-logo",
    clipPath: "url(#clip-Pm-logo)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(679.051 -84.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M-615.766,117.433h-50.823a4.059,4.059,0,0,0-4.059,4.055,4.064,4.064,0,0,0,4.059,4.074h50.823a4.085,4.085,0,0,0,4.084-4.074,4.08,4.08,0,0,0-4.084-4.055",
    transform: "translate(7.438 29.909)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M-596.752,135.181h-73.956v-42.6h73.956Zm4.059-50.709h-82.082a4.065,4.065,0,0,0-4.07,4.061v50.7a4.063,4.063,0,0,0,4.07,4.051h82.082a4.063,4.063,0,0,0,4.072-4.051v-50.7a4.065,4.065,0,0,0-4.072-4.061",
    transform: "translate(0 0)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M-665.656,114.909V102.034a.939.939,0,0,1,.937-.929h5.345a.939.939,0,0,1,.936.929v12.875a.938.938,0,0,1-.936.935h-5.345a.933.933,0,0,1-.937-.935",
    transform: "translate(11.968 15.093)",
    fill: "#ff6b14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M-649.362,123.174V92.92a.93.93,0,0,1,.938-.923h5.343a.927.927,0,0,1,.931.923v30.253a.937.937,0,0,1-.931.935h-5.343a.934.934,0,0,1-.938-.935",
    transform: "translate(26.753 6.828)",
    fill: "#ff6b14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M-648.711,97.97h-5.35a.94.94,0,0,0-.931.935v18.849a.937.937,0,0,0,.931.935h5.35a.934.934,0,0,0,.937-.935V98.9a.938.938,0,0,0-.937-.935",
    transform: "translate(21.645 12.248)",
    fill: "#ff6b14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M-654.042,94.467h-5.348a.927.927,0,0,0-.927.935v25.542a.921.921,0,0,0,.927.923h5.348a.931.931,0,0,0,.937-.923V95.4a.929.929,0,0,0-.937-.935",
    transform: "translate(16.813 9.07)",
    fill: "#ff6b14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M-599.93,106.983l-10.392,15.86h-.7l-10.466-15.86v24.06h-2.094V103.963h2.482l10.39,15.784,10.273-15.784h2.566v27.079h-2.06Z",
    transform: "translate(50.148 17.687)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M-605.51,117.706c.042,6.111,3.92,12.07,11.635,12.07,7.756,0,11.67-5.959,11.67-12.07,0-6.268-3.88-12.032-11.67-12.032s-11.677,5.648-11.635,12.032m25.323.036c-.042,7.117-4.578,13.964-13.688,13.964s-13.69-6.882-13.69-14.04c0-7.269,4.536-13.924,13.69-13.924s13.728,6.689,13.688,14",
    transform: "translate(64.681 17.486)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M-589.68,103.963l18.265,22.4v-22.4h2.052v27.08h-.815l-18.3-22.357v22.357h-2.094v-27.08Z",
    transform: "translate(80.1 17.686)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 2.054,
    height: 27.08,
    transform: "translate(-483.142 121.65)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M-562.67,105.84h-9.81v-1.856h21.714v1.856h-9.81v25.184h-2.094Z",
    transform: "translate(96.518 17.706)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M-557.565,117.706c.042,6.111,3.92,12.07,11.635,12.07,7.756,0,11.67-5.959,11.67-12.07,0-6.268-3.88-12.032-11.67-12.032s-11.677,5.648-11.635,12.032m25.323.036c-.042,7.117-4.576,13.964-13.688,13.964s-13.69-6.882-13.69-14.04c0-7.269,4.536-13.924,13.69-13.924s13.728,6.689,13.688,14",
    transform: "translate(108.187 17.486)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M-540.533,118.816h9.615c4.73,0,6.825-2.668,6.865-6.453a6.252,6.252,0,0,0-6.634-6.462h-9.846Zm19.543,12.227h-2.758l-9.381-10.249h-7.4v10.249h-2.094v-27.08h11.94c5.9,0,8.881,4.219,8.917,8.435.04,4.412-2.869,8.28-8.8,8.28Z",
    transform: "translate(123.606 17.686)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M-622.1,88.447v12.007h8.482c7.813,0,7.813-12.007,0-12.007Zm0,13.648v8.091h-1.81V86.772h10.292c10.191,0,10.191,15.322,0,15.322Z",
    transform: "translate(49.85 2.087)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M-610.572,99.616h8.314c4.088,0,5.9-2.308,5.93-5.581a5.4,5.4,0,0,0-5.732-5.587h-8.513Zm16.9,10.571h-2.384l-8.11-8.86h-6.4v8.86h-1.81V86.773h10.323c5.1,0,7.681,3.647,7.71,7.29.036,3.817-2.48,7.162-7.609,7.162Z",
    transform: "translate(60.309 2.088)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M-599.735,98.655c.036,5.284,3.39,10.435,10.06,10.435,6.707,0,10.09-5.152,10.09-10.435,0-5.419-3.353-10.4-10.09-10.4s-10.094,4.885-10.06,10.4m21.9.031c-.036,6.153-3.956,12.074-11.836,12.074s-11.835-5.951-11.835-12.141c0-6.283,3.922-12.038,11.835-12.038s11.872,5.783,11.836,12.1",
    transform: "translate(70.174 1.914)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M-585.025,88.447v12.007h8.482c7.813,0,7.813-12.007,0-12.007Zm0,13.648v8.091h-1.81V86.772h10.292c10.191,0,10.191,15.322,0,15.322Z",
    transform: "translate(83.491 2.087)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M-573.554,97.576h13.747v1.638h-13.747v9.232h14.822v1.74h-16.6V86.772h16.192v1.711h-14.416Z",
    transform: "translate(93.931 2.087)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M-562.7,99.616h8.315c4.089,0,5.9-2.308,5.936-5.581a5.407,5.407,0,0,0-5.737-5.587H-562.7Zm16.9,10.571h-2.384l-8.11-8.86h-6.4v8.86h-1.81V86.773h10.323c5.1,0,7.679,3.647,7.71,7.29.036,3.817-2.48,7.162-7.609,7.162Z",
    transform: "translate(103.751 2.088)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M-545.029,88.395h-8.482v-1.6h18.775v1.6h-8.482V110.17h-1.81Z",
    transform: "translate(113.73 2.104)",
    fill: "#1c3645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M-533.024,100.82l-9.158-14.012v-.036h2.115l7.944,12.312,7.981-12.312h2.115v.036l-9.188,14.012v9.367h-1.81Z",
    transform: "translate(124.01 2.087)",
    fill: "#1c3645"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmLogo);
export default __webpack_public_path__ + "static/media/pm-logo.44ffffcdcb844b0fd17b0d50524a188a.svg";
export { ForwardRef as ReactComponent };